import { parseCallFailedPayload } from '../../infrastructure/adapters/voiceSocketEventAdapter';
import { voiceRemoveIncomingCall, voiceReleaseCallSession, voiceSetError } from '../../../../../actions/voice/voiceActions';
import {
  getVoiceTabClaimedCallControlId,
  releaseVoiceTabAnswer
} from '../voiceHangupCoordinator';
import { isHangupOwnedByThisTab } from '../../domain/voiceTabCallOwnership';
import { voiceSocketLog } from '../../../../utils/voiceSocketDebug';

export default function callFailedHandler(payload, ports) {
  const parsed = parseCallFailedPayload(payload);
  if (!parsed) {
    voiceSocketLog('call_failed ignored (invalid payload)', payload);
    ports.dispatch(voiceSetError('Invalid call_failed payload'));
    return;
  }

  const { activeCall, incomingCalls, outboundDialingCall } = ports.getHandlerState();
  const isTrackedIncoming = incomingCalls.some(
    (call) => call.callControlId === parsed.callControlId
  );
  const ownedByThisTab = isHangupOwnedByThisTab({
    callControlId: parsed.callControlId,
    activeCallControlId: activeCall?.callControlId ?? null,
    outboundDialingCallControlId: outboundDialingCall?.callControlId ?? null,
    thisTabClaimedCallControlId: getVoiceTabClaimedCallControlId()
  });

  if (!ownedByThisTab && !isTrackedIncoming) {
    voiceSocketLog('call_failed ignored (not this tab)', parsed);
    return;
  }

  ports.dispatch(voiceRemoveIncomingCall(parsed.callControlId));

  if (!ownedByThisTab) {
    voiceSocketLog('call_failed dropped from queue (not this tab)', parsed.callControlId);
    return;
  }

  voiceSocketLog('dispatch call_failed', parsed);
  ports.dispatch(voiceSetError(parsed.reason));
  ports.dispatch(voiceReleaseCallSession(parsed.callControlId));
  releaseVoiceTabAnswer(parsed.callControlId);
}
